module.exports = __webpack_public_path__ + "img/header-mobile.20c37274.jpg";